import toMillis from '../measurementSignals/toMillis'

/**
 * Welke inzending is dit antwoord?
 *
 * `FormID` is het id van één ingevulde vragenlijst; oude documenten dragen het
 * niet en vallen terug op `SessionID` (dezelfde waarde) en daarna op het
 * tijdstempel tot op de milliseconde — de bestaande groeperingsregel voor
 * inzendingen zonder FormID.
 * AI-CONTEXT: See docs/pitfalls.md#database-responses-grouped-by-millisecond-timestamp
 *
 * Valt er niets te groeperen, dan krijgt het document een eigen sleutel. Twee
 * kenmerkloze documenten op één hoop gooien zou de telling stil te LAAG maken,
 * en dat is even onwaar als te hoog.
 *
 * Elke soort sleutel draagt een eigen voorvoegsel, zodat een `SessionID` met de
 * waarde '1000' nooit botst met het tijdstempel 1000.
 *
 * @param {object} response - Een QuestionnairesResponses-document
 * @param {number|null} answeredAtMs - Het tijdstempel, al omgerekend
 * @param {number} index - Positie in de lijst; alleen als laatste redmiddel
 * @returns {string}
 */
export const submissionKey = (response, answeredAtMs, index) => {
    if (typeof response?.FormID === 'string' && response.FormID !== '') return `f:${response.FormID}`
    if (typeof response?.SessionID === 'string' && response.SessionID !== '') return `s:${response.SessionID}`
    if (answeredAtMs !== null && answeredAtMs !== undefined) return `t:${answeredAtMs}`
    return `x:${index}`
}

/**
 * Hoe vaak is de vragenlijst ingevuld?
 *
 * NIET hoeveel documenten er staan: één ingevulde vragenlijst schrijft een
 * document per vraag én per matrixrij, dus documenten tellen geeft een
 * veelvoud. Gemeten op de productiegegevens op 2026-09-18: 87.911 documenten
 * tegenover 7.477 invullingen — mediaan 11x te hoog per organisatie, en bij
 * één organisatie 517x.
 * AI-CONTEXT: See docs/pitfalls.md#database-totaldocs-overcounts-respondents
 *
 * Wil je het aantal ANTWOORDEN tonen, tel dan de documenten zelf. Wil je weten
 * hoeveel MENSEN meededen, dan is dit niet het getal: `FormID` is per inzending,
 * niet per persoon, en bij een anoniem onderzoek valt dat niet te weten.
 *
 * Deze regel staat hier één keer, gedeeld met `deriveResearchAggregate`.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {Array<object>|string|null|undefined} responses - QuestionnairesResponses-documenten.
 *   De leesengine geeft `''` zolang de read loopt; dat telt als 0.
 * @returns {number} Aantal unieke invullingen
 */
const countSubmissions = (responses) => {
    if (!Array.isArray(responses)) return 0

    const keys = new Set()
    responses.forEach((response, index) => {
        keys.add(submissionKey(response, toMillis(response?.Timestamp), index))
    })
    return keys.size
}

export default countSubmissions
